export const APP_NAME = 'RingOut'
export const TAGLINE = 'Never miss a call. Never miss a job.'

export const ROUTES = {
  login: '/login',
  dashboard: '/dashboard',
  dashboardCalls: '/dashboard/calls',
  admin: '/admin',
  adminAccounts: '/admin/accounts',
} as const
